/**
 * Normaliza o numero da nota para o formato F1_DOC (maximo 9 caracteres):
 *   1. remove o "T" dos docs provisorios do portal (DS_DOC "T...");
 *   2. remove o prefixo de ano "2026";
 *   3. mantem os ultimos 9 caracteres.
 *
 * Ex.: "T00005382" -> "00005382"; "202600000011600" -> "000011600".
 *
 * Usado tanto na EXIBICAO do numero (listas + detalhe) quanto na APROVACAO
 * (individual e em lote), para que o numero mostrado bata exatamente com o
 * F1_DOC efetivado pelo MATA103.
 */
export function limparNumeroNf(valor: string | null | undefined): string {
  let s = (valor || '').trim();
  if (s.toUpperCase().startsWith('T')) { s = s.substring(1); }
  if (s.startsWith('2026'))            { s = s.substring(4); }
  if (s.length > 9)                    { s = s.substring(s.length - 9); }
  return s;
}
